    import * as THREE from 'three';
    import Mountains from '../js/Scenes/FxScene1';
    import Earth from '../js/Scenes/FxScene2';
    import Logo from '../js/Scenes/FxScene4';
export default function main() {

const renderer = new THREE.WebGLRenderer();
renderer.setSize( window.innerWidth, window.innerHeight );
let animationScripts = [];
let loadingmanager = new THREE.LoadingManager();
let scene1 = Earth(renderer, loadingmanager, animationScripts)

document.body.appendChild( renderer.domElement );
animate()

function animate() {
    requestAnimationFrame(animate)

  renderer.render( scene1.scene , scene1.camera );

}
    return (
        <>
            <nav className="navbarmb fixed" id="navbar">
                <div className="">
                    <ul className="">
                        <li className="title">
                            <a id="title" href="/initscreen">
                                S.H.A.R.D
                            </a>
                        </li>
                        <li className="">
                            <a id="homebutton" href="/#Home">
                                Home
                            </a>
                        </li>
                        <li className="">
                            <a id="projectsbutton" href="/#Projects">
                                Projects
                            </a>
                        </li>
                        <li className="">
                            <a id="aboutbutton" href="/#About">
                                About
                            </a>
                        </li>
                        <li className="">
                            <a id="contactbutton" href="/#Resources">
                                Contact
                            </a>
                        </li>
                    </ul>
                </div>
            </nav>
        
            

        </>
    )
}